'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Headphones = function Headphones(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-headphones ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,12.84375 C26,14.546875 25.6875,16.203125 25.0625,17.75 L24.75,18.515625 L21.859375,19.03125 C21.40625,20.734375 19.859375,22 18,22 L18,22.5 C18,22.78125 17.78125,23 17.5,23 L16.5,23 C16.21875,23 16,22.78125 16,22.5 L16,13.5 C16,13.21875 16.21875,13 16.5,13 L17.5,13 C17.78125,13 18,13.21875 18,13.5 L18,14 C19.5,14 20.796875,14.828125 21.484375,16.046875 L22.546875,15.859375 C22.84375,14.890625 23,13.890625 23,12.84375 C23,8.125 18.328125,4 13,4 C7.671875,4 3,8.125 3,12.84375 C3,13.890625 3.15625,14.890625 3.453125,15.859375 L4.515625,16.046875 C5.203125,14.828125 6.5,14 8,14 L8,13.5 C8,13.21875 8.21875,13 8.5,13 L9.5,13 C9.78125,13 10,13.21875 10,13.5 L10,22.5 C10,22.78125 9.78125,23 9.5,23 L8.5,23 C8.21875,23 8,22.78125 8,22.5 L8,22 C6.140625,22 4.59375,20.734375 4.140625,19.03125 L1.25,18.515625 L0.9375,17.75 C0.3125,16.203125 0,14.546875 0,12.84375 C0,6.421875 5.953125,1 13,1 C20.046875,1 26,6.421875 26,12.84375 Z' })
  );
};

Headphones.propTypes = _bcPropTypes.iconShape;

exports.default = Headphones;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Headphones/Headphones.js
// module id = 243
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16